module.exports = __webpack_public_path__ + "static/Sample-1-d4e58d5be506b55bed8563cc11bf48b8.png";